module.exports = __webpack_public_path__ + "static/media/sent-icon.0f694ce1.svg";